angular.module('rjmNg.directives').directive 'columnDetailLabel', [
  () ->
    restrict:"E"
    templateUrl: "directive.columnDetailLabel.html"
    priority: 200
    replace: true
    scope:
      column: '='
      search: '<'
    controller: [
      "$scope"
      "dataTypeNames"
      "app"
      (
        $scope
        dataTypeNames
        app
      ) ->

        $scope.name = null
        $scope.isPrimaryKey = false
        $scope.currenyCode = null
        $scope.dataType = null

        defaultCurrencyCode = app.getClientDefaultCurrency()?.code

        $scope.update = () ->
          if $scope.column?
            $scope.name = $scope.column.name
            $scope.isPrimaryKey = $scope.column.primary_key_index
          else
            $scope.name = null
            $scope.isPrimaryKey = false

          if $scope.column?.field_type is 'value_currency'
            $scope.currencyCode =
              $scope.column.currency_code ? defaultCurrencyCode
          else
            $scope.currencyCode = null

          $scope.dataType = dataTypeNames[$scope.column.data_type.type]

    ]
    link: (scope) ->

      scope.$watchGroup(
        [
          'column.name'
          'column.is_primary_key'
          'column.field_type'
          'column.currency_code'
          'column.data_type.type'
        ]
        scope.update
      )

      scope.update()

]
